import defaultUrl from './api';
const urls = {
    // 登录
    login: 'api/admin/login',
    // 验证码
    captcha: 'api/config/captcha',
    // 退出登录
    logout: 'api/admin/logout',
    // 左侧菜单
    menuList: 'api/menu/index',
    // 栏目列表
    columnList: 'api/column/index',
    // 栏目列表-全部数据
    columnAllData: 'api/column/getlist',
    // 栏目添加
    columnAdd: 'api/column/store',
    // 栏目显示/隐藏
    columnShowHidden: 'api/column/hidden',
    // 栏目详情
    columnDetail: 'api/column/show',
    // 栏目修改
    columnEdit: 'api/column/update',
    // 栏目删除
    columnDelete: 'api/column/destory',
    // 栏目更新排序
    columnSort: 'api/column/changesort',
    // 栏目-批量移动
    columnMove: 'api/column/move',
    // 栏目-批量复制
    columnCopy: 'api/column/copy',
    // 栏目-商品分类列表
    columnGoodsCateList: 'api/column/columncate',
    // 网站页面模块-轮播、分类样式列表
    webModuleList: 'api/columngoodscate/index',
    // 网站页面模块-轮播、分类样式列表-添加
    webModuleAdd: 'api/columngoodscate/store',
    // 网站页面模块-获取当前项详情（轮播、分类样式列表-详情）
    webModuleDetail: 'api/columngoodscate/show',
    // 网站页面模块-编辑当前项（轮播、分类样式列表-编辑）
    webModuleEdit: 'api/columngoodscate/update',
    // 网站页面模块-删除（轮播、分类样式列表-删除）
    webModuleDelete: 'api/columngoodscate/destory',
    // 网站页面模块-轮播图-上/下线
    webModuleBannerOnline: 'api/columngoodscate/online',
    // 网站页面模块-分类样式-显示/隐藏
    webModuleCateHidden: 'api/columngoodscate/hidden',
    // 网站页面模块-分类样式-排序
    webModuleCateSort: 'api/columngoodscate/changesort',
    // 网站页面模块-分类样式-商品列表
    webCateGoodsList: 'api/columngoods/index',
    // 网站页面模块-分类样式-商品列表-添加商品
    webCateGoodsAdd: 'api/columngoods/store',
    // 网站页面模块-分类样式-商品列表-置顶
    webCateGoodsTop: 'api/columngoods/top',
    // 网站页面模块-分类样式-商品列表-删除
    webCateGoodsDelete: 'api/columngoods/destory',
    // 网站页面模块-列表样式-列表
    webModuleGoodsList: 'api/columngoodslist/index',
    // 网站页面模块-列表样式-添加商品
    webModuleGoodsAdd: 'api/columngoodslist/store',
    // 网站页面模块-列表样式-删除
    webModuleGoodsDelete: 'api/columngoodslist/destory',
    // 网站页面模块-列表样式-置顶
    webModuleGoodsTop: 'api/columngoodslist/top',
    // 政策扶持列表
    policySupportList: 'api/columngoodscate/index',
    // 政策扶持列表-添加
    policySupportAdd: 'api/columngoodscate/store',
    // 政策扶持列表-置顶
    policySupportTop: 'api/columngoodscate/top',
    // 政策扶持列表-详情
    policySupportDetail: 'api/columngoodscate/show',
    // 政策扶持列表-编辑
    policySupportEdit: 'api/columngoodscate/update',
    // 政策扶持列表-删除
    policySupportDelete: 'api/columngoodscate/destory',
    // 商品分类-分类列表
    goodsCateList: 'api/cate/index',
    // 商品分类-分类列表-添加
    goodsCateAdd: 'api/cate/store',
    // 商品分类-分类列表-详情
    goodsCateDetail: 'api/cate/show',
    // 商品分类-分类列表-编辑
    goodsCateEdit: 'api/cate/update',
    // 商品分类-分类列表-删除
    goodsCateDelete: 'api/cate/destory',
    // 商品分类-分类列表-排序
    goodsCateSort: 'api/cate/changesort',
    // 商品分类-分类列表-批量移动
    goodsCateMove: 'api/cate/move',
    // 商品分类-分类列表-批量复制
    goodsCateCopy: 'api/cate/copy',
    // 商品审核列表
    goodsAuditList: 'api/goodsapply/index',
    // 商品审核列表-详情
    goodsAuditDetail: 'api/goodsapply/show',
    // 商品审核列表-审核
    goodsAudit: 'api/goodsapply/check',
    // 商品列表
    goodsList: 'api/goods/index',
    // 商品列表-添加
    goodsAdd: 'api/goods/store',
    // 商品列表-详情
    goodsDetail: 'api/goods/show',
    // 商品列表-编辑
    goodsEdit: 'api/goods/update',
    // 商品列表-编辑-上下架
    goodsChangeSale: 'api/goods/changesale',
    // 商品列表-删除
    goodsDelete: 'api/goods/destory',
    // 订单管理-订单列表
    orderList: 'api/order/index',
    // 订单管理-订单列表-详情
    orderDetail: 'api/order/show',
    // 订单管理-订单列表-删除(移至回收站)
    orderDelete: 'api/order/recovery',
    // 订单管理-订单列表-删除(清空回收站)
    orderClear: 'api/order/destory',
    // 订单管理-订单列表-还原删除
    orderReduction: 'api/order/reduction',
    // 订单管理-评价列表
    orderEvaluateList: 'api/ordersevaluate/index',
    // 订单管理-评价列表-详情
    orderEvaluateDetail: 'api/ordersevaluate/show',
    // 订单管理-评价列表-置顶
    orderEvaluateTop: 'api/ordersevaluate/top',
    // 订单管理-评价列表-删除
    orderEvaluateDelete: 'api/ordersevaluate/destory',
    // 订单管理-评价列表-回复
    orderEvaluateReply: 'api/ordersevaluate/reply',
    // 交付方式列表
    payTypeList: 'api/paytype/index',
    // 交付方式列表-添加
    payTypeAdd: 'api/paytype/store',
    // 使用系统列表
    usedSystemList: 'api/system/index',
    // 使用系统列表-添加
    usedSystemAdd: 'api/system/store',
    // 委托开通-申请列表
    authorizeApplyList: 'api/commissioning/index',
    // 委托开通-申请列表-详情
    authorizeApplyDetail: 'api/commissioning/show',
    // 委托开通-申请列表-删除
    authorizeApplyDelete: 'api/commissioning/destory',
    // 广告管理-广告审核列表
    advertisingAuditList: 'api/advertisement/applylist',
    // 广告管理-广告审核列表-详情
    advertisingAuditDetail: 'api/advertisement/applydetail',
    // 广告管理-广告审核列表-审核
    advertisingAudit: 'api/advertisement/check',
    // 广告管理-广告列表
    advertisingList: 'api/advertisement/index',
    // 广告管理-广告列表-添加
    advertisingAdd: 'api/advertisement/store',
    // 广告管理-广告列表-详情
    advertisingDetail: 'api/advertisement/show',
    // 广告管理-广告列表-编辑
    advertisingEdit: 'api/advertisement/update',
    // 广告管理-广告列表-删除
    advertisingDelete: 'api/advertisement/destory',
    // 广告管理-广告列表-置顶
    advertisingTop: 'api/advertisement/top',
    // 广告管理-广告列表-邀请
    advertisingInvitation: 'api/advertisement/invitation',
    // 行业分类列表
    industryList: 'api/industry/index',
    // 行业分类列表-添加
    industryAdd: 'api/industry/store',
    // 行业分类列表-详情
    industryDetail: 'api/industry/show',
    // 行业分类列表-编辑
    industryEdit: 'api/industry/update',
    // 行业分类列表-删除
    industryDelete: 'api/industry/destory',
    // 行业分类列表-排序
    industrySort: 'api/industry/changesort',
    // 行业分类列表-批量移动
    industryMove: 'api/industry/move',
    // 行业分类列表-批量复制
    industryCopy: 'api/industry/copy',
    // 服务商-审核列表
    facilitatorAuditList: 'api/service/applylist',
    // 服务商-审核列表-审核
    facilitatorAudit: 'api/service/check',
    // 服务商-审核列表-详情
    facilitatorAuditDetail: 'api/service/applydetail',
    // 服务商-审核列表-删除
    facilitatorAuditDelete: 'api/service/applydelete',
    // 服务商列表
    facilitatorList: 'api/service/index',
    // 服务商列表-添加
    facilitatorAdd: 'api/service/store',
    // 服务商列表-详情
    facilitatorDetail: 'api/service/show',
    // 服务商列表-编辑
    facilitatorEdit: 'api/service/update',
    // 服务商列表-删除
    facilitatorDelete: 'api/service/destory',
    // 服务商列表-置顶
    facilitatorTop: 'api/service/top',
    // 服务商列表-编辑-初始化密码
    facilitatorInitPwd: 'api/service/originalpwd',
    // 服务商列表-成功案例-列表
    facSuccessCaseList: 'api/servicecase/index',
    // 服务商列表-成功案例-添加
    facSuccessCaseAdd: 'api/servicecase/store',
    // 服务商列表-成功案例-详情
    facSuccessCaseDetail: 'api/servicecase/show',
    // 服务商列表-成功案例-编辑
    facSuccessCaseEdit: 'api/servicecase/update',
    // 服务商列表-成功案例-删除
    facSuccessCaseDelete: 'api/servicecase/destory',
    // 服务商列表-成功案例-排序
    facSuccessCaseSort: 'api/servicecase/changesort',
    // 服务商-商品列表-未被领取的商品列表
    facilitatorAllGoodsList: 'api/service/getnullgoodlist',
    // 服务商-商品列表
    facilitatorGoodsList: 'api/service/goodslist',
    // 服务商-商品列表-删除
    facilitatorGoodsDelete: 'api/service/deletegoods',
    // 服务商-商品列表-领取商品
    facilitatorGoodsAdd: 'api/service/putgoods',
    // 课程管理-课程审核列表
    courseAuditList: 'api/course/applylist',
    // 课程管理-课程审核列表-详情
    courseAuditDetail: 'api/course/applydetail',
    // 课程管理-课程审核列表-审核
    courseAudit: 'api/course/check',
    // 课程管理-课程审核列表-删除
    courseAuditDelete: 'api/course/applydelete',
    // 课程管理-课程列表
    courseList: 'api/course/index',
    // 课程管理-课程列表-添加
    courseAdd: 'api/course/store',
    // 课程管理-课程列表-详情
    courseDetail: 'api/course/show',
    // 课程管理-课程列表-编辑
    courseEdit: 'api/course/update',
    // 课程管理-课程列表-删除
    courseDelete: 'api/course/destory',
    // 课程管理-课程列表-编辑-追加课程
    addCourseItems: 'api/course/appendcourse',
    // 课程管理-课程列表-编辑-编辑课程项
    editCourseItems: 'api/course/editcourse',
    // 课程管理-课程列表-编辑-删除课程项
    deleteCourseItems: 'api/course/deletedetail',
    // 课程管理-技术领域列表
    technosphereList: 'api/technicalfield/index',
    // 角色列表
    roleList: 'api/role/index',
    // 用户列表(会员列表)
    userList: 'api/user/index',
    // 用户列表(会员列表)-详情
    userDetail: 'api/user/show',
    // 用户列表(会员列表)-详情-订单列表
    userOrderList: 'api/user/orders',
    // 通知类型列表
    systemNoticeTypeList: 'api/messagecate/index',
    // 通知类型列表-添加
    systemNoticeTypeAdd: 'api/messagecate/store',
    // 通知类型列表-详情
    systemNoticeTypeDetail: 'api/messagecate/show',
    // 通知类型列表-编辑
    systemNoticeTypeEdit: 'api/messagecate/update',
    // 通知类型列表-删除
    systemNoticeTypeDelete: 'api/messagecate/destory',
    // 系统通知列表
    systemNoticeList: 'api/message/index',
    // 系统通知列表-添加
    systemNoticeAdd: 'api/message/store',
    // 系统通知列表-详情
    systemNoticeDetail: 'api/message/show',
    // 系统通知列表-删除
    systemNoticeDelete: 'api/message/destory',
    // 系统通知列表-接受对象列表
    systemNoticeObjectList: 'api/message/objectlist',
    // 五朵云分类
    otherCloudCateList: 'api/catecloud/index',
    // 五朵云分类-添加
    otherCloudCateAdd: 'api/catecloud/store',
    // 五朵云分类-详情
    otherCloudCateDetail: 'api/catecloud/show',
    // 五朵云分类-编辑
    otherCloudCateEdit: 'api/catecloud/update',
    // 五朵云分类-删除
    otherCloudCateDelete: 'api/catecloud/destory',
    // 五朵云分类-复制
    otherCloudCateCopy: 'api/catecloud/copy',
    // 五朵云分类-移动
    otherCloudCateMove: 'api/catecloud/move',
    // 五朵云分类-排序
    otherCloudCateSort: 'api/catecloud/changesort',
    // 用户分类绑定到系统分类
    userBindSystemCate: 'api/catebinding/store',
    // 系统分类绑定到用户分类
    systemBindUserCate: 'api/catebinding/bindingcloud',
    // 商品列表-商品绑定系统分类
    goodsBindSystemCates: 'api/catebinding/bindinggoods',
    // 商品列表-商品绑定用户分类
    goodsBindUserCates: 'api/catebinding/cloudbindinggoods',
    // 小程序-模块列表
    appletModelsList: 'api/wxsystemuser/getmodel',
    // 上传图片
    uploadImage: 'api/upload/images',
    // 上传视频
    uploadVideo: 'api/upload/videos',
    // 上传文件
    uploadFiles: 'api/upload/files',
    // 微信扫码支付
    wxScanPay: 'api/pay/scan',
    // 发送注册短信
    sendRegisterMessage: 'api/sms/register',
    // 发送登录短信
    sendLoginMessage: 'api/sms/login',
    // 清除缓存
    clearCache: 'api/cache/clear',
    // 省市区数据
    areaList: 'api/region/index',
};
Object.keys(urls).forEach(el => {
    urls[el] = defaultUrl + urls[el];
});
export default urls;


// WEBPACK FOOTER //
// ./src/ws/apiUrl.js